import { Nav, NavItem, NavLink } from "reactstrap";
import { SimpleNavProps } from "../../../../Types/UiKitsType";

const PillNav: React.FC<SimpleNavProps> = ({ basicTab, setBasicTab }) => {
  return (
    <Nav tabs>
      <NavItem>
        <NavLink
          href={"#"}
          className={basicTab === "1" ? "active" : ""}
          onClick={() => setBasicTab("1")}
        >
          <i className="fa fa-cubes me-2"></i>Structure Overview
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          href={"#"}
          className={basicTab === "2" ? "active" : ""}
          onClick={() => setBasicTab("2")}
        >
          <i className="fa fa-cogs me-2"></i>Division Maintenance
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          href={"#"}
          className={basicTab === "3" ? "active" : ""}
          onClick={() => setBasicTab("3")}
        >
          <i className="fa fa-cogs me-2"></i>Department Maintenance
        </NavLink>
      </NavItem>
    </Nav>
  );
};
export default PillNav;
